import Vue from 'vue'
import Vuex from 'vuex'


import axios from 'axios';
import * as firebase from 'firebase/app';

// eslint-disable-next-line
import * as firebaseAuth from 'firebase/auth';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userLoaded: false,
    idToken: "",
    locationsLoaded: false,
    locations:[],
    url:"",
    accountDetails: -1,
  },
  mutations: {
    addLocation(state, Payload){
      state.locations.push(Payload);
    },
    setLocation(state, Payload){
      state.locations.find(location => location.id === Payload.LocationID).title = Payload.UpdateLocationDTO.newTitle;
    },
    setIdToken(state, newToken){
      state.idToken = newToken;
    },
    setUrl(state, newUrl){
      state.url = newUrl;
    },
    loadLocations(state, newLocations){
      state.locations=newLocations;
    },
    setAccount(state, newAccount){
      state.accountDetails = newAccount;
    },
    setUserLoaded(state, newValue){
      state.userLoaded = newValue;
    }
  },
  actions: {
    changeUser({commit}, user){

      commit('setUserLoaded', true);

    },
    updateLocation({commit, state}, Payload){
      var s=state;
      var t = this;
      return new Promise((resolve, reject)=> {
        this.dispatch("getTokenConfig").then(function(config){
    
          axios.put( 
            s.url  + "locations/" + Payload.LocationID,
            Payload.UpdateLocationDTO, 
             config
          ).then((response) => {
              if(response.data==1){
                commit('setLocation', Payload)
              }
          
              resolve(response.data);
    
          }).catch((error) => {
              console.log("error:" + error)
          });
          

        });
      });
    },
    returnLocationCheckIns({commit, state},locationID){
      var t =state;
      return new Promise((resolve, reject) => {


        firebase.auth().currentUser.getIdToken().then(function(idToken) { 
          var config = {
                  headers: {'Authorization': "bearer " + idToken}
          };     
       axios.get( 
         t.url  + 'locations/' + locationID + "/CheckIns",
          config
      ).then((response) => {

      
          resolve(response.data);

      }).catch((error) => {
          console.log("error:" + error)
      });

      });
    });

    },
    addLocation({commit, state}){
      var t =this;
      var s = state;
  

      
      return new Promise((resolve, reject) => {


        t.dispatch("getTokenConfig").then(function(config) { 
       axios.post( 
        s.url  + "locations",
         {}, 
         config
      ).then((response) => {

          commit('addLocation', response.data)
          resolve(response.data);

      }).catch((error) => {
          console.log("error:" + error)
      });

      });
    });
    },
    addQRCode({commit, state}, qrCode){
      var t =state;
      return new Promise((resolve, reject) => {


        firebase.auth().currentUser.getIdToken().then(function(idToken) { 
          var config = {
                  headers: {'Authorization': "bearer " + idToken}
          };     
       axios.post( 
         t.url  + 'locations/' + qrCode.LocationID + "/QRCodes",
         qrCode, 
         config
      ).then((response) => {

      
          resolve(response.data);

      }).catch((error) => {
          console.log("error:" + error)
      });

      });
    });
    },
    returnQRCodes({commit, state},locationID){
      var t =state;
      return new Promise((resolve, reject) => {


        firebase.auth().currentUser.getIdToken().then(function(idToken) { 
          var config = {
                  headers: {'Authorization': "bearer " + idToken}
          };     
       axios.get( 
         t.url  + 'locations/' + locationID + "/QRCodes",
          config
      ).then((response) => {

      
          resolve(response.data);

      }).catch((error) => {
          console.log("error:" + error)
      });

      });
    });

    },
    getTokenConfig({commit, state}){

      return new Promise((resolve,reject)=>{
        if(state.idToken==""){
        return firebase.auth().currentUser.getIdToken().then(function(idToken){
            state.idToken = idToken;
            resolve({
                headers: {'Authorization': "bearer " + idToken}
              });
        });        
      }else{
        resolve({
            headers: {'Authorization': "bearer " + state.idToken}
          });
      };
    });
    },
    getToken({commit, state}){
      return new Promise((resolve,reject)=>{
        if(state.idToken==""){
        return firebase.auth().currentUser.getIdToken().then(function(idToken){
            state.idToken = idToken;
            resolve(idToken);
        });        
      }else{
        resolve(state.idToken);
      };
    });
    },
    loadAccount({commit, state}){
      var t =this;
      var s = state;
  
     
      
      return new Promise((resolve, reject) => {


        t.dispatch("getTokenConfig").then(function(config) { 


       axios.get( 
        s.url  + "Account",
         config
      ).then((response) => {

          commit('setAccount', response.data)
          resolve(response.data);

      }).catch((error) => {
          console.log("error:" + error)
      });

      });
    });

    
    },
    loadClients({commit, state}){
      var store = this;
      var t =state;

      return new Promise((resolve, reject) => {

          if(state.clientsLoaded){
              resolve(state.clients);
          }else{

                 firebase.auth().currentUser.getIdToken().then(function(idToken) { 
                  var config = {
                          headers: {'Authorization': "bearer " + idToken}
                  };     
               axios.get( 
                 t.url  + 'locations',
                  config
              ).then((response) => {
  
                  state.locations= response.data;
                  state.locationsLoaded  =true;
                  commit("loadLocations", response.data);
                  resolve(state.locations);
  
              }).catch((error) => {
                  console.log("error:" + error)
              });
          });
          }
      });
  },
  },
  getters:{
    returnUserLoaded:state=>
    {
      return state.userLoaded;
    },
    getLocationByID: (state) => (id) => {
      return state.locations.find(location => location.id === id);
    },
    returnAccount:state=>
    {
      return state.accountDetails;
    },
    getLocations:state=>{
        return state.locations;
    },
    getIdToken: state=>{
      return state.idToken;
    },
    getAxiosConfig: state=>{


        return {
          headers: { Authorization: "Bearer " + state.idToken }
        }
      

        },
        getAxiosConfigBlob: state=>{
          return {
            headers: { Authorization: "Bearer " + state.idToken, responseType: 'blob' }
        }
        
  
          }
    }
      
  })
